// toastr messages
export const REQUESTED_NUMBER_OF_CONTACTS_FIRST_TIME: number = 20;
export const REQUESTED_NUMBER_OF_CONTACTS: number = 10;
export const TRIGGER_SCROLL_HEIGHT: number = 10;